<template>
  <div>
    <HeaderView class="header" />
    <section class="layout">
      <transition
        name="fade-transform"
        mode="out-in"
      >
        <keep-alive :max="1">
          <router-view :key="key" />
        </keep-alive>
      </transition>
    </section>

    <FooterView class="footer" />
  </div>
</template>
  
<script>
import HeaderView from "@/components/Header/index.vue"
import FooterView from "@/components/Footer/index.vue"
  
export default {
    name: "App",
    components: {
        HeaderView,
        FooterView
    },
    computed: {
        key () {
            return this.$route.path
        }
    },
    watch: {
    },
    created () {
    },
    methods: {
    }
}
</script>
  
  <style lang="scss" scoped>
  .layout {
    /*50 = navbar  */
    min-height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  .fixed-header+.layout {
    padding-top: 50px;
  }

  .header{
    position: fixed;
    z-index: 100;
    width: 100%;
  }

  .footer {
    width: 100%;
    background-color: #f8f8f8;
    padding: 10px 0px;
    margin-top: auto; 
    box-sizing: border-box;
  }
  </style>